import { checkPermission } from '@/utils/directive/permission' // 权限判断函数

export default {
  inserted(el, binding, vnode) {
    const { name, value } = binding

    let permission = []

    if (name === 'audit-manager') {
      permission = ['AUTH_CODE_SYS_ADM']
    }

    if (name === 'trans-download') {
      permission = ['AUTH_CODE_TRANSACTION_STATISTICS']
    }
    if (name === 'disbursement-check') {
      permission = ['ROLE_AUTH_DISBURSEMENT_CHECK']
    }
    if (name === 'disbursement-confirm') {
      permission = ['ROLE_AUTH_DISBURSEMENT_CONFIRM']
    }
    if (name === 'disbursement-approve') {
      permission = ['ROLE_AUTH_DISBURSEMENT_APPROVE']
    }

    if (name === 'recharge') {
      permission = ['AUTH_CODE_RECHARGE']
    }

    if (name === 'withdraw') {
      permission = ['AUTH_CODE_WITHDRAW']
    }

    if (name === 'transfer') {
      permission = ['ROLE_AUTH_SETTLEMENT_TRANSFER']
    }

    if (name === 'trans-details') {
      permission = ['ROLE_AUTH_SETTLEMENT_BALANCE_DETAIL']
    }

    if (name === 'permission') {
      if (value && value instanceof Array && value.length > 0) {
        permission = value
      } else {
        throw new Error(`need roles! Like v-permission="['admin','editor']"`)
      }
    }

    const hasPermission = checkPermission(permission)

    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}
